export default "\n<router-outlet></router-outlet>\n\n<app-notification></app-notification>\n"